import * as yup from 'yup';

export const BaseFormSchema = yup.object({
  residentId: yup.string().required(),
  createdById: yup.string().required(),
});
export type IBaseForm = yup.InferType<typeof BaseFormSchema>;

export const UpdateBaseFormSchema = yup.object({
  id: yup.string().required(),
  residentId: yup.string().optional(), // TODO: maybe we can assume that a given residentId is immutable, i.e. in most cases it does not make sense to transfer a form from one resident to another does it?
});
export type IUpdateBaseForm = yup.InferType<typeof UpdateBaseFormSchema>;
